import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { SmsService } from 'src/app/services/sms-service/smsservice';
import { UserStorageService } from 'src/app/services/user-storage-service/user-storage.service';

@Component({
  selector: 'app-sms-smss-breadcrumb-card',
  templateUrl: './sms-smss-breadcrumb-card.component.html',
  styleUrls: ['./sms-smss-breadcrumb-card.component.scss']
})
export class SmsSmssBreadcrumbCardComponent implements OnInit {

  @Input() smss;
  filterOpened: boolean;
  viewDisposition;

  constructor(private router: Router,
              private userStorageService: UserStorageService,
              private smsService: SmsService) {
                this.viewDisposition = 'grid';
              }

  ngOnInit() {
    // if (this.userStorageService.getFilterNotifications()) {
    //   this.toggleBreadcrumbFilter();
    // }
  }

  public toggleViewDisposition(viewDis) {
    this.viewDisposition = viewDis;
    this.smsService.toggleSmssDisposition(viewDis);
  }

  public createSms() {
    this.router.navigate(['/account/sms']);
  }

  // public toggleBreadcrumbFilter() {
  //   this.filterOpened = !this.filterOpened;
  // }

  public search(event) {
    this.smsService.searchSms(event.target.value);
  }
}
